(function() { window.GUID_1b4ac237_881d_4bcd_a407_3ade11ade655 = { getGuid: function() { return "1b4ac237-881d-4bcd-a407-3ade11ade655"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let TimeFrame;
        (function (TimeFrame) {
            TimeFrame[TimeFrame["Current"] = 0] = "Current";
            TimeFrame[TimeFrame["Year"] = 1] = "Year";
            TimeFrame[TimeFrame["NextWeek"] = 2] = "NextWeek";
            TimeFrame[TimeFrame["NextMonth"] = 3] = "NextMonth";
            TimeFrame[TimeFrame["NextYear"] = 4] = "NextYear";
            TimeFrame[TimeFrame["LastWeek"] = 5] = "LastWeek";
            TimeFrame[TimeFrame["LastMonth"] = 6] = "LastMonth";
            TimeFrame[TimeFrame["LastYear"] = 7] = "LastYear";
            TimeFrame[TimeFrame["Older"] = 10] = "Older";
            TimeFrame[TimeFrame["All"] = 100] = "All";
        })(TimeFrame = Enumeration.TimeFrame || (Enumeration.TimeFrame = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=TimeFrame.pre.js.map
